import React from "react";
import WidgetWrapper from "components/WidgetWrapper";
import FlexBetween from "components/FlexBetween";
import { Box, Button, Dialog, DialogContent, DialogTitle } from "@mui/material";
import PersonAddAltOutlinedIcon from "@mui/icons-material/PersonAddAltOutlined";
import { useUserAdmin } from "./hooks/useUserAdmin";
import UserForm from "./Components/UserForm";
import UserGrid from "./Components/userGrid";
import Header from "components/Header";

function UserAdmin() {
  const {
    isLargeScreen,
    open,
    editMode,
    currentUser,
    handleOpen,
    handleEditOpen,
    handleClose,
    setOpen,
    showLocation,
  } = useUserAdmin();

  return (
    <Box m={isLargeScreen ? "1rem" : "1.5rem 0.5rem 2rem 0.5rem"}>
      <WidgetWrapper>
        <FlexBetween>
          <Header
            title="ALT Coach - User Admin"
            subtitle="Administer your users' details"
          />
          {showLocation && (
            <Button
              variant="contained"
              color="primary"
              sx={{
                borderRadius: "5px",
                fontSize: "12px",
                padding: "5px 10px",
              }}
              onClick={handleOpen}
            >
              <PersonAddAltOutlinedIcon sx={{ mr: "0.5rem" }} />
              Add new User
            </Button>
          )}
        </FlexBetween>

        <UserGrid handleEditOpen={handleEditOpen} />

        {/* The Dialog component is a modal dialog that is displayed over the current page. */}
        <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
          <DialogTitle>
            {editMode
              ? `Edit User - ${currentUser.firstName} ${currentUser.lastName}`
              : "Add a New User to your Organisation"}
          </DialogTitle>
          <DialogContent>
            <UserForm
              editMode={editMode}
              currentUser={currentUser}
              setOpen={setOpen}
              handleClose={handleClose}
            />
          </DialogContent>
        </Dialog>
      </WidgetWrapper>
    </Box>
  );
}

export default UserAdmin;
